import { DB } from "@/services/firebase/db"
import { Auth } from "@/services/firebase/auth"
import firebase from "firebase/compat"
import firestore = firebase.firestore
import News from "@/types/news/news"

export class NewsService {
  storeNews (title: string, news: string[]) {
    return DB.collection('news').doc().set({
      createdAt: new Date().getTime(),
      title: title,
      news: news,
      seenBy: []
    })
  }

  getAllNewNewsForUser () {
    return DB.collection('news')
      .where('seenBy', 'not-in', Auth.currentUser?.uid)
      .get()
      .then((newsQuery) => {
        return newsQuery.docs.map((doc) => {
          return new News({
            id: doc.id,
            from: doc.data().createdAt,
            news: doc.data().news,
            title: doc.data().title
          })
        })
      })
  }

  addUserToSeenBy (newsId: string) {
    return DB.collection('news').doc(newsId).set({
      seenBy: firestore.FieldValue.arrayUnion(Auth.currentUser?.uid)
    }, { merge: true })
  }

  getAllNews () {
    return DB.collection('news')
      .get()
      .then((newsQuery) => {
        return newsQuery.docs.map((doc) => {
          return new News({
            id: doc.id,
            from: doc.data().createdAt,
            news: doc.data().news,
            title: doc.data().title
          })
        })
      })
  }

  removeNews (newsId: string) {
    return DB.collection('news').doc(newsId).delete()
  }
}
